import { Trait } from "./trait"

interface TraitType {
  key: {
    value: string
    count: number
  }
  values: {
    value: string
    count: number
  }[]
}

interface Props {
  availableTraits: TraitType[]
}

export function TraitsFilter({ availableTraits }: Props) {
  return (
    <div className="flex flex-col gap-4">
      {availableTraits.map((trait) =>
        trait.values.length ? (
          <Trait
            key={trait.key.value}
            trait={{ name: trait.key.value, values: trait.values }}
          />
        ) : null,
      )}
    </div>
  )
}
